import BaseViewController from "./base-view-controller";
import {
  getAdjustedToCignaAppData,
  getAdjustedToCignaFields
} from "../utils/cigna-date-time-picker-helper";

class AdvanceMedicalAppointmentVideoScheduleViewController extends BaseViewController {
  preprocessScreenData() {
    this.appData = getAdjustedToCignaAppData(
      this.appData,
      this.screen.conditionals,
      this.screen.fields
    );
    this.screen.fields = getAdjustedToCignaFields(this.screen.fields);
  }
}

export default AdvanceMedicalAppointmentVideoScheduleViewController;
